/* scale-tool.js — «To scale» del panel «Inside the piece» (lote pdp-window,
   v11, B2-bis, 31 oct 2026). Sin dependencias. El marcado y la regla, en
   `snippets/scale-tool.liquid`; el aspecto, en `assets/scale-tool.css`.

   QUÉ HACE
     · On the body: la figura es fija (su alto lo pone el CSS: 430 px en
       escritorio, 360 en móvil) y el bolso se dibuja a
       `px por cm = alto de la figura / altura elegida`. Cuelga según
       `data-carry`: del hombro (parte alta a `strap / 2 − 15` cm bajo el
       hombro, con dos líneas a las esquinas; sin correa, a la cadera, sin
       líneas), a la espalda (parte alta en el hombro) o de la mano
       (0,58 del alto). Altura: chips y un campo de 140 a 210; fuera de rango
       no cambia nada y el campo dice `aria-invalid`.
     · Next to: el bolso y un objeto de la lista de abajo, a la misma escala,
       sobre una línea de suelo; la escala es la mayor que cabe en la caja.
     · Cambio de vista con una clase, sin transición (regla 6); el
       segmentado con flechas y Home/End.
     · Nada se guarda: ni `localStorage`, ni cookie. Nada se pide a la red:
       el packshot es el `currentSrc` de la foto 01 del visor, ya cargada.
     · Dibuja al abrir el panel (`acaciasupplies.scale.draw()`, lo llama
       `v10-product.js`) y al cambiar el ancho de la caja: con el panel
       cerrado las cajas miden 0 y no hay nada que dibujar.

   LOS OBJETOS: lista cerrada, en cm (ancho × alto, de frente). No están en
   el admin a propósito: son medidas de norma o de catálogo, no datos de una
   pieza. */
(function (w, d) {
  'use strict';
  var as = w.acaciasupplies = w.acaciasupplies || {};
  if (as.scale) return;

  var OBJECTS = [
    { key: 'a4', name: 'A4 sheet', w: 21, h: 29.7 },
    { key: 'laptop-13', name: '13-inch laptop', w: 30.4, h: 21.2 },
    { key: 'laptop-16', name: '16-inch laptop', w: 35.6, h: 24.8 },
    { key: 'bottle-500', name: '500 ml bottle', w: 6.5, h: 21 },
    { key: 'passport', name: 'Passport', w: 8.8, h: 12.5 },
    { key: 'paperback', name: 'Paperback', w: 11, h: 18 }
  ];
  var MIN_H = 140;
  var MAX_H = 210;
  var GAP_CM = 12;
  var SVG = 'http://www.w3.org/2000/svg';

  /* Proporciones de la figura (viewBox 0 0 120 400): el hombro y la espalda,
     la cadera y la mano, en unidades del dibujo. Son del dibujo, no de una
     persona: la figura no cambia nunca. */
  var FIG = { vw: 120, vh: 400, cx: 60, shoulderX: 70, shoulderY: 78, backX: 36, handX: 64, hip: 0.47, hand: 0.58 };

  function cmText(n) {
    var r = Math.round(n * 10) / 10;
    return String(r);
  }
  function px(n) { return (Math.round(n * 100) / 100) + 'px'; }
  function place(el, x, y, wd, ht) {
    if (!el) return;
    el.style.left = px(x);
    el.style.top = px(y);
    if (wd != null) el.style.width = px(wd);
    if (ht != null) el.style.height = px(ht);
  }
  function lines(svg, wd, ht, list) {
    if (!svg) return;
    svg.setAttribute('viewBox', '0 0 ' + wd + ' ' + ht);
    svg.setAttribute('preserveAspectRatio', 'none');
    while (svg.firstChild) svg.removeChild(svg.firstChild);
    list.forEach(function (l) {
      var ln = d.createElementNS(SVG, 'line');
      ln.setAttribute('x1', l[0]); ln.setAttribute('y1', l[1]);
      ln.setAttribute('x2', l[2]); ln.setAttribute('y2', l[3]);
      if (l[4]) ln.setAttribute('class', l[4]);
      svg.appendChild(ln);
    });
  }
  function dimLine(x1, x2, y) {
    return [[x1, y, x2, y], [x1, y - 5, x1, y + 5], [x2, y - 5, x2, y + 5]];
  }

  function Tool(root) {
    this.root = root;
    this.W = +root.getAttribute('data-w');
    this.H = +root.getAttribute('data-h');
    this.strap = +root.getAttribute('data-strap') || 0;
    this.carry = root.getAttribute('data-carry') || 'none';
    this.height = 170;
    this.obj = OBJECTS[0];
    this.view = this.carry === 'none' ? 'next' : 'body';
    this.views = {};
    var self = this;
    root.querySelectorAll('[data-scale-view]').forEach(function (v) { self.views[v.getAttribute('data-scale-view')] = v; });
    this.tabs = Array.prototype.slice.call(root.querySelectorAll('[data-scale-tab]'));
    this.chips = Array.prototype.slice.call(root.querySelectorAll('[data-scale-h]'));
    this.input = root.querySelector('[data-scale-input]');
    this.buildObjects();
    this.bind();
  }

  Tool.prototype.buildObjects = function () {
    var ul = this.root.querySelector('[data-scale-objects]');
    if (!ul) return;
    var self = this;
    this.objChips = OBJECTS.map(function (o, i) {
      var li = d.createElement('li');
      var b = d.createElement('button');
      b.type = 'button';
      b.className = 'pdp-chip v10-mono';
      b.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
      b.setAttribute('data-scale-o', o.key);
      b.textContent = o.name;
      b.addEventListener('click', function () { self.setObject(o); });
      li.appendChild(b);
      ul.appendChild(li);
      return b;
    });
  };

  Tool.prototype.bind = function () {
    var self = this;
    this.tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { self.setView(t.getAttribute('data-scale-tab'), false); });
      t.addEventListener('keydown', function (e) {
        var k = e.key;
        var to = k === 'ArrowRight' || k === 'ArrowDown' ? i + 1 : k === 'ArrowLeft' || k === 'ArrowUp' ? i - 1 : k === 'Home' ? 0 : k === 'End' ? self.tabs.length - 1 : null;
        if (to === null) return;
        e.preventDefault();
        to = (to + self.tabs.length) % self.tabs.length;
        self.setView(self.tabs[to].getAttribute('data-scale-tab'), true);
      });
    });
    this.chips.forEach(function (c) {
      c.addEventListener('click', function () { self.setHeight(+c.getAttribute('data-scale-h')); });
    });
    if (this.input) {
      this.input.addEventListener('input', function () {
        var raw = self.input.value.trim();
        var n = Number(raw);
        if (raw === '' || !isFinite(n) || Math.round(n) !== n || n < MIN_H || n > MAX_H) {
          self.input.setAttribute('aria-invalid', 'true');
          return;
        }
        self.input.removeAttribute('aria-invalid');
        self.setHeight(n, true);
      });
      this.input.addEventListener('change', function () {
        if (self.input.getAttribute('aria-invalid') === 'true') {
          self.input.value = String(self.height);
          self.input.removeAttribute('aria-invalid');
        }
      });
    }
    if ('ResizeObserver' in w) {
      var ro = new ResizeObserver(function () { self.draw(); });
      this.root.querySelectorAll('[data-scale-box]').forEach(function (b) { ro.observe(b); });
    }
  };

  Tool.prototype.setView = function (view, focus) {
    this.view = view;
    var self = this;
    Object.keys(this.views).forEach(function (k) { self.views[k].classList.toggle('is-hidden', k !== view); });
    this.tabs.forEach(function (t) {
      var on = t.getAttribute('data-scale-tab') === view;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      if (on && focus) t.focus();
    });
    this.draw();
  };

  Tool.prototype.setHeight = function (h, fromInput) {
    if (!(h >= MIN_H && h <= MAX_H)) return;
    this.height = h;
    this.chips.forEach(function (c) { c.setAttribute('aria-pressed', +c.getAttribute('data-scale-h') === h ? 'true' : 'false'); });
    if (this.input && !fromInput) { this.input.value = String(h); this.input.removeAttribute('aria-invalid'); }
    var out = this.root.querySelector('[data-scale-height]');
    if (out) out.textContent = String(h);
    this.drawBody();
  };

  Tool.prototype.setObject = function (o) {
    this.obj = o;
    (this.objChips || []).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-scale-o') === o.key ? 'true' : 'false'); });
    this.drawNext();
  };

  Tool.prototype.photo = function () {
    var bag = this.root.querySelector('[data-scale-bag]');
    if (!bag || bag.querySelector('[data-scale-photo]')) return;
    /* La foto 01 del visor (escritorio) o del carrusel (móvil): la misma,
       ya cargada; su `currentSrc` sale de la caché, sin petición nueva. */
    var first = d.querySelector('[data-v10-gallery] [data-v10-slide] img');
    var src = first && (first.currentSrc || first.getAttribute('src'));
    /* La `<img>` se crea aquí y solo con la foto ya cargada: en el HTML no
       hay ninguna `<img>` sin `src` (`scripts/qa/placeholders.mjs`). */
    if (src && first.complete) {
      var img = d.createElement('img');
      img.className = 'pdp-scale__photo';
      img.alt = '';
      img.setAttribute('data-scale-photo', '');
      img.src = src;
      bag.appendChild(img);
    }
  };

  Tool.prototype.drawBody = function () {
    var view = this.views.body;
    if (!view || view.classList.contains('is-hidden')) return;
    var box = view.querySelector('[data-scale-box]');
    var CW = box.clientWidth;
    var CH = box.clientHeight;
    if (!CW || !CH) return;
    var fig = view.querySelector('[data-scale-fig]');
    /* Un `<svg>` no tiene `offsetTop`: el alto y la posición, de su caja. */
    var fr = fig.getBoundingClientRect();
    var FH = fr.height;
    var FT = fr.top - box.getBoundingClientRect().top - box.clientTop;
    if (!FH) return;
    var s = FH / FIG.vh;
    var figW = FIG.vw * s;
    var cx = Math.round(CW * 0.45);
    var figL = cx - FIG.cx * s;
    fig.style.left = px(figL);
    fig.style.width = px(figW);
    var ground = FT + FH;
    var ppc = FH / this.height;
    var bagW = this.W * ppc;
    var bagH = this.H * ppc;
    var sx = figL + FIG.shoulderX * s;
    var sy = FT + FIG.shoulderY * s;
    var bagL, bagT;
    var strapOn = this.carry === 'shoulder' && this.strap > 0;
    if (this.carry === 'shoulder') {
      bagT = strapOn ? sy + (this.strap / 2 - 15) * ppc : FT + FIG.hip * FH;
      bagL = cx - bagW / 2;
    } else if (this.carry === 'back') {
      bagT = sy;
      bagL = figL + FIG.backX * s - bagW;
    } else {
      bagT = FT + FIG.hand * FH;
      bagL = figL + FIG.handX * s - bagW / 2;
    }
    var bagR = bagL + bagW;
    var bag = view.querySelector('[data-scale-bag]');
    place(bag, bagL, bagT, bagW, bagH);
    this.photo();

    var list = [];
    if (strapOn) {
      list.push([sx, sy, bagL + Math.min(8, bagW / 4), bagT, 'is-strap']);
      list.push([sx, sy, bagR - Math.min(8, bagW / 4), bagT, 'is-strap']);
    }
    list = list.concat(dimLine(bagL, bagR, ground + 14));
    var hx = CW - 72;
    list.push([hx, FT, hx, ground], [hx - 6, FT, hx + 6, FT], [hx - 6, ground, hx + 6, ground]);
    lines(view.querySelector('[data-scale-over]'), CW, CH, list);

    var tag = function (k) { return view.querySelector('[data-scale-tag="' + k + '"]'); };
    var tw = tag('w');
    if (tw) place(tw, Math.max(4, (bagL + bagR) / 2 - tw.offsetWidth / 2), ground + 24);
    var th = tag('h');
    if (th) place(th, Math.max(4, bagL - th.offsetWidth - 8), bagT + bagH / 2 - th.offsetHeight / 2);
    var ts = tag('strap');
    if (ts) {
      ts.hidden = !strapOn;
      place(ts, Math.min(CW - ts.offsetWidth - 4, (sx + bagR) / 2 + 14), (sy + bagT) / 2 - ts.offsetHeight / 2);
    }
    var tf = tag('height');
    if (tf) place(tf, Math.min(CW - tf.offsetWidth - 4, hx + 10), FT + FH / 2 - tf.offsetHeight / 2);
  };

  Tool.prototype.drawNext = function () {
    var view = this.views.next;
    if (!view || view.classList.contains('is-hidden')) return;
    var box = view.querySelector('[data-scale-box]');
    var CW = box.clientWidth;
    var CH = box.clientHeight;
    if (!CW || !CH) return;
    var o = this.obj;
    var L = CW < 500 ? 24 : 48;
    var maxH = parseFloat(getComputedStyle(box).getPropertyValue('--scale-next-h')) || 340;
    var sc = Math.min((CW - 2 * L) / (this.W + o.w + GAP_CM), maxH / Math.max(this.H, o.h));
    var nbW = this.W * sc, nbH = this.H * sc, noW = o.w * sc, noH = o.h * sc;
    var base = (CH + Math.max(nbH, noH)) / 2 - 10;
    var nbL = L, noL = L + nbW + GAP_CM * sc;
    place(view.querySelector('[data-scale-nbag]'), nbL, base - nbH, nbW, nbH);
    place(view.querySelector('[data-scale-obj]'), noL, base - noH, noW, noH);
    var list = [[Math.max(8, L - 16), base, CW - Math.max(8, L - 16), base]];
    list = list.concat(dimLine(nbL, nbL + nbW, base + 10), dimLine(noL, noL + noW, base + 10));
    lines(view.querySelector('[data-scale-over]'), CW, CH, list);
    var tb = view.querySelector('[data-scale-tag="nbag"]');
    if (tb) place(tb, nbL, base + 22);
    var to = view.querySelector('[data-scale-tag="obj"]');
    if (to) {
      to.textContent = o.name + ' · ' + cmText(o.w) + ' × ' + cmText(o.h) + ' cm';
      to.style.right = '16px';
      to.style.left = 'auto';
      to.style.top = px(base + 22);
    }
  };

  Tool.prototype.draw = function () {
    this.drawBody();
    this.drawNext();
  };

  var tools = [];
  function init() {
    d.querySelectorAll('[data-scale-tool]').forEach(function (root) {
      if (root.__scale) return;
      try {
        root.__scale = new Tool(root);
        tools.push(root.__scale);
      } catch (err) {
        console.error('scale-tool: could not start', err);
      }
    });
  }
  as.scale = {
    objects: OBJECTS.map(function (o) { return { key: o.key, name: o.name, w: o.w, h: o.h }; }),
    draw: function () { tools.forEach(function (t) { t.draw(); }); }
  };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init);
  else init();
})(window, document);
